import { API } from 'aws-amplify';
import { useState } from 'react';
import { t } from 'i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';

import Button from '../shared/Button';
import View from '../shared/View';

import './WithdrawApp.scss';
import { Box, Dialog, DialogContent, DialogTitle } from '@mui/material';

export default function WithdrawApp(props) {
    const [name] = useState(!!props?.app?.StudentName ? props.app.StudentName.split(' ')[0] : 'student');
    const [checked, setChecked] = useState(false);
    const [saving, setSaving] = useState(false);

    let withdrawClick = async () => {
        setSaving(true);

        try {
            await API.patch('ShipyardAPI', `/application/${props.app.ID}`, {
                body: {
                    status: 12,
                },
            });

            props.close(true);
        } catch (e) {
            toast.error(t('General.AjaxError'));
        }

        setSaving(false);
    };

    let viewTitle = `Withdraw ${name}'s application`;

    let viewJSX = (
        <View name="withdraw-app">
            <Dialog open={true}>
                <DialogTitle>{viewTitle}</DialogTitle>
                <DialogContent>
                    <Box className="withdraw-app-body">
                        <div className="withdraw-app-instructions">{t('WithdrawApp.Instructions')}</div>

                        <div>
                            <label>
                                <input
                                    type="checkbox"
                                    onChange={(e) => setChecked(e.target.checked)}
                                />{' '}
                                {t('WithdrawApp.CheckboxLabel')}
                            </label>
                        </div>
                    </Box>
                    <Box>
                        <Button
                            useMui={true}
                            defaultText={t('General.Cancel')}
                            type="grey"
                            onClick={() => (typeof props.close === 'function' ? props.close() : null)}
                            interactive={false}
                        />
                        <Button
                            useMui={true}
                            defaultText={t('WithdrawApp.WithdrawButton')}
                            onClick={() => (typeof props.close === 'function' ? withdrawClick() : null)}
                            interactive={false}
                            disabled={!checked || saving}
                        />
                    </Box>
                </DialogContent>
            </Dialog>
        </View>
    );

    let loadingJSX = (
        <div className="loading-withdraw-app">
            <FontAwesomeIcon icon={faSpinner} />
        </div>
    );

    return !!name ? viewJSX : loadingJSX;
}
